module.exports = __webpack_public_path__ + "media/images/flags/TZ-507612e45ccc6bcd4916a86a3fadc46e.svg";